export default {
  message: {
    "error": "¡Ups! Algo salió mal.",
    "Sorrysomeerrorsoccurred": "Ocurrió un error inesperado. Puedes intentar cambiar el idioma o salir y reiniciar la aplicación.",
    "quit": "Salir",
    "language": "Idioma",
    "Youcanchangethelanguagehere": "¡Puedes cambiar el idioma aquí!",
    "current": "Actual",
    "home": "Inicio",
    "friends": "Amigos",
    "wallet": "Billetera",
    "aboutus": "Sobre nosotros",
    "Sharewithfriends": "Compartir con amigos",
    "copyFailure": "Error al copiar",
    "copySuccess": "Éxito al copiar",
    "Claimreward": "Recibir recompensa",
    "DailyLogin": "Inicio de sesión diario",
    "noInvitationsYet": "Aún sin invitaciones",
    "LoadMore": "Cargar más",
    "WatchAD": "Ver anuncio",
    "continue": "Continuar",
    "Congratulations": "Felicidades",
    "MyFriends": "Mis amigos",
    "Invitefriends": "Invitar amigos",
    "Invitepremiumfriends": "Invitar amigos premium",
    "DailyTasks": "Actividades diarias",
    "inviteDesc": "+{num} ${name} por cada amigo que invites",
    "DailyTasksDesc": "Completa tareas para obtener más airdrop",
    "SponsorsandPartners": "Patrocinadores y socios",
    "Receivingwallet": "Billetera receptora",
    "Enterwalletaddress": "Ingresa la dirección de billetera {name}",
    "Claim": "Recibir",
    "Booster": "Acelerador",
    "RentPeriod": "Período de alquiler",
    "days30": "30 días",
    "Dailyprofit": "Ganancia diaria",
    "Totalprofit": "Ganancia total",
    "Quantity": "Cantidad",
    "RentPrice": "Precio de alquiler",
    "RentMiner": "Alquilar minero",
    "Insufficient": "No hay suficientes invitados",
    "InsufficientMsg": "Necesitas invitar {num} amigos para ganar más accesorios.",
    "Settings": "Configuraciones",
    "copyid": "Copiar ID",
    "UpgradeSuccessfully": "Actualización exitosa",
    "Name": "Nombre",
    "userinfo": "Información del usuario",
    "disconnect": "Desconectar",
    "Startmining": "Comenzar a minar",
    "Welcome": "Bienvenido a {name}",
    "Withdrawal": "Retiro",
    "Minimumamount": "Cantidad mínima",
    "Networkfee": "Tarifa de red",
    "Enteramount": "Ingresar cantidad",
    "Submit": "Enviar",
    "MinimumTip": "La cantidad de retiro es demasiado pequeña. Monto mínimo de retiro: {num}",
    "MaximumTip": "Cantidad insuficiente, la cantidad máxima que puedes retirar es: {num}",
    "SubmittedTip": "Enviado, se espera que se procese en un plazo de 30-60 días hábiles",
    "WithdrawStatus": "Estado",
    "Submissiontime": "Hora de envío",
    "WithdrawAwaitTip": "* Se estima que tomará 30-60 días hábiles. Invitar a más amigos puede acelerar el proceso de revisión.",
    "Processing": "Procesando",
    "Amount": "Cantidad",
    "Numberoffriends": "Número de amigos: {now}/{limit}",
    "InviteTip": "Para hacer tu primer retiro, necesitas invitar a {limit} amigos a unirse a la aplicación de minería.",
    "openonphone": "Abre este enlace en tu teléfono.",
    "claimTip": "La cantidad a recibir es demasiado pequeña. La cantidad mínima a recibir es: {num}",
    "WalletBalance": "Saldo de cartera",
    "Withdraw": "Retirar",
    "SetWalletAddress": "Establecer dirección de cartera",
    "WithdrawalRecord": "Registro de retiros",
    "Norecords": "No hay registros",
    "Whatis": "¿Qué es {name}?",
    "All": "Todo",
    "save": "Guardar",
    "successWithdrawal": "Escaneo exitoso {num}",
    "secondsago": "{time} segundos hace",
    "Loading": "Cargando...",
    "PaymentConfirming": "Comprobando el estado de la transacción...",
    "Check": "Comprobar",
    "CheckFail": "Transacción no completada. Por favor, verifica nuevamente en 5 segundos.",
    "Addname": "Agregar '{name}' a tu nombre",
    "Restattcheck": "Reinicia la aplicación para verificar",
    "Copyname": "Copiar '{name}'",
    "SubmissionFailed": "Error en el envío, por favor intenta nuevamente más tarde",
    "WithdrawalReview": "Revisión de retiro",
    "WebWithdrawAwaitTip": "* Se estima que tomará 24-48 horas. Invitar a más amigos puede acelerar el proceso de revisión.",
    "Success": "Éxito",
    "Rejection": "Rechazo",
    "WebSubmittedTip": "Enviado, lo procesaremos lo antes posible.",
    "select_payment_method": "Seleccionar método de pago",
    "total_amount": "Monto total",
    "next_step": "Siguiente paso",
    "creating_order": "Creando pedido...",
    "order_created": "Pedido creado",
    "order_status": "Estado del pedido",
    "order_id": "ID del pedido",
    "order_amount": "Cantidad del pedido",
    "order_status_desc": "Descripción del estado del pedido",
    "payment_cancelled": "Pago cancelado",
    "opening_payment": "Abrir pago...",
    "payment_success": "Pago exitoso",
    "payment_failed": "Pago fallido",
    "payment_pending": "Pago pendiente",
    "payment_processing": "Procesando pago",
    "create_order_failed": "Error al crear la orden",
    "creating_ton_order": "Creando orden de TON...",
    "check_payment_status": "Verificando estado del pago...",
    "use_ton_payment": "Usar pago TON",
    "connect_wallet": "Conectar billetera",
    "start_transaction": "Iniciar transacción",
    "address": "Dirección",
    "amount_ton": "Cantidad TON",
    "copy": "Copiar",
    "comment_memo": "Comentario",
    "comment_memo_desc": "Por favor ingrese el comentario",
    "comment_memo_placeholder": "Ingrese comentario",
    "amount": "Cantidad",
    "wallet_address": "Dirección de billetera",
    "you_can_choose_to_connect_wallet_to_pay": "Puede elegir conectar la billetera para pagar",
    "or_manually_transfer_to_the_above_address": "O transferir manualmente a la dirección anterior (note que la cantidad y el comentario deben ser exactamente iguales)",
    "transaction_success": "Transacción exitosa",
    "transaction_failed": "Transacción fallida",
    "transaction_error": "Error en la transacción",
    "transaction_status": "Estado de la transacción",
    "transaction_id": "ID de la transacción",
    "transaction_amount": "Cantidad de la transacción",
    "transaction_status_desc": "Descripción del estado de la transacción",
    "miner_detail": "Detalles del minero",
    "rent_period": "Periodo de alquiler",
    "days": "{days} días",
    "daily_yield": "Rendimiento diario",
    "total_yield": "Rendimiento total",
    "invite_friends": "Invitar amigos",
    "price": "Precio",
    "rent": "Alquilar",
    "free_claim": "Recompensa gratuita",
    "redeem": "Canjear",
    "buy": "Alquilar",
    "invite_friends_not_enough": "No suficientes amigos invitados",
    "redeem_success": "Canje exitoso",
    "redeem_failed": "Canje fallido",
    "rent_success": "Alquiler exitoso",
    "rent_failed": "Alquiler fallido",
    "TotalPower": "Poder total",
    "MaxQuantity": "Valor máximo alcanzado",
    "Running": "Ejecutando",
    "Stop": "Detener",
    "InviteTipFirst": "Para hacer tu primer retiro, necesitas invitar a {limit} amigos a unirse a la app de minería.",
    "Withdrawalunlock": "Desbloqueo de retiro",
    "Close": "Cerrar",
    "Delivering": "Entregando",
    "Duetothelargenumber": "Debido al gran número de destinatarios, se espera que tu airdrop llegue en 15-20 días hábiles",
    "WithdrawalunlockTip": "Necesitas {num} amigos invitados para completar tareas/vincular billeteras para desbloquear el retiro",
    "mining_title": "Robot",
    "Upgrade": "Mejorar",
    "partner": "Socio",
    "faq": "Preguntas frecuentes",
    "task": "Tarea",
    "OpenRobot": "Abrir Robot",
    "MyRobot": "Mi Robot",
    "Level": "Nivel",
    "Commission": "Comisión",
    "DirectFriends": "Amigos Directos",
    "Feedback": "Comentarios",
    "Pleaseenteryouremailaddress": "Por favor, introduce tu dirección de correo electrónico",
    "Inputfeedbackcontent": "Introduce el contenido del comentario",
    "Submitfeedback": "Enviar comentario",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Comentario enviado correctamente, gracias por tus valiosos comentarios",
    "Feedbacksubmissionfailed,pleaseretriy": "Error al enviar el comentario, por favor intenta de nuevo",
    "Addressformaterror": "Error en el formato de la dirección",
    "Readclipboardfailed": "Error al leer el portapapeles",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Ya has comentado hoy, por favor vuelve mañana",
    "Record": "Registro",
    "Newuserguidance": "Ver Tour de Bienvenida",
    "Usetonwallet": "Usar billetera TON",
    "Reward": "Recompensa",
    "Connectwallet": "Conectar billetera",
    "Notconnected": "No conectado",
    "Disconnect": "Desconectar",
    "AboutTAI": "Detalles del Token",
    "WithdrawalRecordDesc": "Registro de retiros",
    "StartAItrading": "Iniciar comercio AI",
    "Next": "Siguiente",
    "Start": "Iniciar",
    "WithdrawalSuccess": "Retiro exitoso",
    "WithdrawalFail": "Falló el retiro",
    "Max": "Máx",
    "WithdrawalRecords": "Registros de Retiros",
    "Commissionrules": "Reglas de comisiones",
    "Mycommission": "Mi comisión",
    "Shop": "Tienda",
    "BuyDifferentAIrobots": "¡Mejora con dispositivos de computación para escaneos más rápidos!",
    "CurrentRunningAIrobots": "Robots de IA en funcionamiento",
    "DailyProfit": "Beneficio diario",
    "Buy": "Comprar",
    "ValidityPeriod": "Periodo de validez",
    "Days": "Días",
    "Price": "Precio",
    "APY": "APY",
    "NoRobot": "No hay potencia de computación",
    "RemainingTime": "Tiempo restante",
    "InviteandEarn": "Invitar y ganar",
    "InvitDec": "¡Invita a tus amigos a unirse al trading de IA y gana comisiones en USDT y tokens airdrop juntos!",
    "ShareToGroups": "Compartir en grupos",
    "Select_payment_method": "Selecciona el método de pago",
    "twa_pay_tip_with_memo": "Por favor, asegúrate de que la dirección, el monto y el memo sean consistentes para la transferencia.",
    "twa_pay_tip": "Por favor, asegúrate de que la dirección y el monto sean correctos para la transferencia.",
    "twa_pay_tip_placeholder": "Ingresa el comentario",
    "twa_pay_tip_placeholder_with_memo": "Ingresa el comentario con memo",
    "twa_pay_tip_placeholder_without_memo": "Ingresa el comentario sin memo",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Ingresa el comentario con memo",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Ingresa el comentario sin memo",
    "realtime_ai": "Trading de IA en Tiempo Real",
    "check_transaction_status": "Verificar el estado de la transacción",
    "transaction_wait": "La transacción está en proceso. Puedes salir de la aplicación. Un mensaje te notificará una vez que esté completa.",
    "Pleaseenteravalidemailaddress": "Por favor, introduce una dirección de correo electrónico válida",
    "max_robot_tip": "Límite de compra alcanzado — prueba otro plan para seguir comerciando!",
    "connectFailure": "No se pudo conectar la billetera",
    "connectSuccess": "Billetera conectada con éxito",
    "PayNow": "Pagar ahora",
    "min_withdrawal_amount": "El monto mínimo de retiro es {num} {coin_name}",
    "max_withdrawal_amount": "El monto máximo de retiro es {num} {coin_name}",
    "balance_not_enough": "No tienes suficiente saldo para este retiro.",
    "Numberofgroups": "Número de grupos: {now}/{limit}",
    "Withdraw_success": "Retiro exitoso",
    "allProfit": "Beneficio total",
    "AnnualProfit": "Beneficio anual",
    "ScanWallet": "Escanear Billetera",
    "wallet_check": "wallet_check",
    "Found": "Encontrado",
    "ScanSpeed": "Velocidad de escaneo",
    "MyComputingPower": "Computar",
    "Scanning": "¡Scaneando!",
    "WithdrawDetail": "Detalles del retiro",
    "ScanSuccess": "¡Tu tasa de éxito de escaneo ha aumentado!",
    "TaskDescription": "¡Completa tareas para aumentar tu tasa de éxito de escaneo!",
    "InitializingMiningSystem": "Iniciando el sistema de escaneo...",
    "NoWithdrawalRecord": "No hay registro de retiro",
    "Invite": "Invitaciones requeridas",
    "Free": "Gratis",
    "Confirm": "Confirmar",
    "RefreshTasks": "Actualizar tareas",
    "NumberofGroups": "Número de grupos: {now}/{limit}",
    "SendMessage": "Enviar mensaje",
    "NumberofShares": "Número de acciones: {now}/{limit}",
    "NumberofTasks": "Número de tareas: {now}/{limit}",
    "CompleteTask": "Completar tarea",
    "Accelerated": "Acelerado",
    "Accelerated_withdrawals_success": "Retiros acelerados exitosamente",
    "GoBuy": "Ir a Comprar",
    "SpeedUpScan": "Acelerar",
    "Earnings": "Ganancias",
    "learnMore": "Aprender más",
    "claimSuccess": "Recompensas recibidas con éxito",
    "claimFailed": "Error al recibir, por favor intenta de nuevo",
    "noDividends": "No hay dividendos para recibir",
    "dividendsInfoFallback": "Invita a amigos para ganar recompensas por referencia"
}};